import request from '@/utils/request'

// 获取瑕疵图片列表
export function getDefectImageList(params) {
  return request({
    url: '/api/admin/defect-image/list',
    method: 'get',
    params
  })
}

// 添加瑕疵图片
export function addDefectImage(data) {
  return request({
    url: '/api/admin/defect-image/add',
    method: 'post',
    data
  })
}

// 更新瑕疵图片
export function updateDefectImage(data) {
  return request({
    url: '/api/admin/defect-image/update',
    method: 'post',
    data
  })
}

// 删除瑕疵图片
export function deleteDefectImage(id) {
  return request({
    url: '/api/admin/defect-image/delete',
    method: 'post',
    params: { id }
  })
}

// 根据检测项目ID获取瑕疵图片列表
export function getDefectImagesByItemId(itemId) {
  return request({
    url: '/api/admin/defect-image/by-item',
    method: 'get',
    params: { itemId }
  })
} 